{
  "anySpecialist": {
    "text": "Whakaaturia mai ngā wā wātea whānui rawa atu mō ngā whakaritenga.",
    "title": "Kāore au e māharahara ko wai"
  },
  "nextLabel": "$t(common:next): <b>Kōwhiria he wā</b>",
  "profile": "Kōtaha Mātanga",
  "specialists": {
    "00000000-0000-da7a-0003-000000000004": {
      "name": "Dr. Lopez"
    }
  },
  "textMultiple": "<p>He pai katoa ēnei mātanga. Kōwhiria tētahi, kāore rānei — tohua noa te “Kāore au e māharahara ko wai”.</p>",
  "textSingle": "<p>आपके जीपी – {{referral.gp}} – ने आपको यहां रेफर किया है:</p>",
  "titleMultiple": "Kōwhiria tō mātanga",
  "titleSingle": "Tō mātanga",
  "viewProfile": "Tirohia te kōtaha katoa"
}
